import { Component, ErrorInfo, ReactNode } from 'react';
import { log } from '../../utils/errorHandler';

interface IErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    log(`[Render error]: ${error.message} ${errorInfo.componentStack}`);
  }

  render(): ReactNode {
    const { children, fallback } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        fallback ?? (
          <div className="main_container" role="alert">
            <h1>Something went wrong.</h1>
            <p>Please refresh the page and try again.</p>
          </div>
        )
      );
    }

    return children;
  }
}

export default ErrorBoundary;
